import { render, staticRenderFns } from "./screens.vue?vue&type=template&id=5359a08d&"
import script from "./screens.vue?vue&type=script&lang=js&"
export * from "./screens.vue?vue&type=script&lang=js&"
import style0 from "./screens.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports